'use strict';

wbApp.directive('wbCourseScheduleCombo', ['$timeout', '$translate', '$filter', 'courseScheduleSvc',
    function ($timeout, $translate, $filter, courseScheduleSvc) {
        function formatResult(courseSchedule) {
            if (!courseSchedule) { return; }

            return "<div class='row'>" +
                        "<div class='col-md-2'>" + $filter('date')(courseSchedule.startDate, 'dd.MM.yy') + "</div>" +
                        "<div class='col-md-3'>" +
                            $filter('date')(courseSchedule.startDate, 'EEE HH:mm').toUpperCase() +
                            ' - ' +
                            $filter('date')(courseSchedule.endDate, 'HH:mm').toUpperCase() +
                        "</div>" +
                        "<div class='col-md-6'>" + courseSchedule.teacher + "</div>" +
                        "<div class='col-md-1'>" + courseSchedule.filled + '/' + courseSchedule.capacity + "</div>" +
                    "</div>";
        }

        function formatSelection(courseSchedule) {
            return $filter('date')(courseSchedule.startDate, 'dd. MM. yyyy - (EEE HH:mm').toUpperCase() +
                   ' - ' +
                   $filter('date')(courseSchedule.endDate, 'HH:mm)').toUpperCase();
        }

        return {
            restrict: 'A',
            require: 'ngModel',
            priority: 1,
            replace: true,
            scope: {
                courseId: '=',
                ngModel: '='
            },
            link: function (scope, elm, attrs, ctrl) {

                var schedules = !!scope.courseId
                    ? courseScheduleSvc.getAllSortedAsync(scope.courseId)
                    : [];

                $timeout(function () {
                    $(elm).select2({
                        placeholder: $translate.instant('TXT_PLACEHOLDER_SELECT_COURSE_SCHEDULE'),
                        formatResult: formatResult,
                        formatSelection: formatSelection,
                        dropdownAutoWidth: true,
                        allowClear: false,
                        minimumResultsForSearch: -1,
                        id: function (schedule) { return schedule.courseScheduleID; },
                        data: schedules
                    });

                    ctrl.$render = function () {
                        if(ctrl.$viewValue) {
                            if (!schedules.$promise) {
                                schedules = courseScheduleSvc.getAllSortedAsync(ctrl.$viewValue)
                            }

                            schedules.$promise.then(function () {
                                $(elm).select2('val', ctrl.$viewValue);
                            });
                        }
                    }

                    scope.$watch('courseId', function (newValue) {
                        if (!!newValue) {
                            var newSchedules = courseScheduleSvc.getAllSortedAsync(newValue);
                            newSchedules.$promise.then(function () {
                                if (newSchedules !== schedules) {
                                    schedules.length = 0;
                                    schedules.push.apply(schedules, newSchedules);
                                }

                                for (var i = 0; i < schedules.length; i++) {
                                    if (schedules[i].courseScheduleID == ctrl.$viewValue) {
                                        return;
                                    }
                                }

                                $(elm).select2('val', null);
                                ctrl.$setViewValue(null);
                            })
                        } else {
                            $(elm).select2('val', null);
                            ctrl.$setViewValue(null);
                        }
                    });

                    elm.bind("$destroy", function () {
                        elm.select2("destroy");
                    });

                    attrs.$observe('readonly', function (value) {
                        elm.select2('readonly', !!value);
                    });

                    ctrl.$render();

                }, 1);
            }
        }
    }]);